/*
Copyright MITSUBISHI Elec.
*/

var bizId;
var userRole = BlenderConstants.AUTHORITY_TYPE_SHOW_AND_EDIT;
var dirtyFlg;
var ignoreDirtyFlg;
var errorFlg;
var blockCnt = 0;
var chainCloseFlag = false;
var blockCloseFlag = false;

/**
 * 業務用パネル等の初期化用。
 * 
 * @module blenderinit
 * @class blenderinit
 */

$(function(){

	BlenderUserInput.setupDisableUserInput();

	loadOperationPanel();

	$(document).click(function (e) {
		// 画面クローズ時のクリックでイベント通知が遅れ、スクリプトが無効となる場合があるため、typeofでチェック
		if( typeof(_getWinMan)=="function" && _getWinMan() ) {
			_getWinMan().hideMenuBar();
		}
	});

	if( !$("#bodyPanel").hasClass("blender-operation-panel") ) {
		$("#bodyPanel").addClass("blender-operation-panel");
	}

	$(window).on("unload", function(){
		unloadOperationPanel();
	});

	BlenderUtil.setupFocusTraversal();
});

/**
 * 業務IDを設定する。
 * @method setBizId
 * @param _bizId 業務ID
 */
function setBizId(_bizId) {
	bizId = _bizId;
}

/**
 * ユーザ権限を設定する。
 * @method setUserRole
 * @param _userRole ユーザ権限
 */
function setUserRole(_userRole) {
	userRole = _userRole;
}

/**
 * ユーザ権限を取得する。
 * @method getUserRole
 * @param _bizId 業務ID
 * @return ユーザ権限
 */
function getUserRole(_bizId) {
	return _getWinMan().getRole(_bizId);
}

/**
 * 連鎖クローズフラグを設定する。
 * @method setChainCloseFlag
 * @param _chainCloseFlag 連鎖クローズフラグ
 */
function setChainCloseFlag(_chainCloseFlag) {
	chainCloseFlag = _chainCloseFlag;
}

/**
 * クローズ防止フラグを確認する。
 * @method isBlockClose
 * @return クローズ防止フラグ(クローズを防止する場合true)
 */
function isBlockClose() {
	return blockCloseFlag;
}

/**
 * クローズ防止フラグを設定する。
 * @method setBlockCloseFlag
 * @param _blockCloseFlag クローズ防止フラグ(クローズを防止する場合true)
 */
function setBlockCloseFlag(_blockCloseFlag) {
	blockCloseFlag = _blockCloseFlag;
}

/**
 * 画面権限を設定する。
 * @method setupAuthority
 */
function setupAuthority() {

	if( userRole != BlenderConstants.AUTHORITY_TYPE_SHOW_AND_EDIT ) {
		BlenderUtil.changeBtnCondition(
			"input[type='button'][actionType='"+BlenderConstants.ACTION_TYPE_REGIST+"']",
			BlenderUtil.BTN_CONDITION_DISABLE);

		var grids = BlenderObjectManager.getObjectsByType("grid");
		for( var i=0; i<grids.length; i++ ) {
			grids[i].readonly();
		}

		var calendarpanels = BlenderObjectManager.getObjectsByType("calendarpanel");
		for( var i=0; i<calendarpanels.length; i++ ) {
			calendarpanels[i].readonly();
		}
	}
}

/**
 * 画面権限を変更する。
 * @method changeAuthority
 * @param newUserRole 新規権限
 */
function changeAuthority(newUserRole) {
	if( null!=newUserRole && userRole!=newUserRole ) {
		userRole = newUserRole;
		setupAuthority();
	}
}

/**
 * パネルサイズを設定する。
 * @method setPanelSize
 * @param width 幅
 * @param height 高さ
 */
function setPanelSize(width,height) {
	var bodyPanel = $("#bodyPanel");
	if( null != bodyPanel.html() ) {
		bodyPanel.width(width).height(height);
		var tCls = "dhtmlx_skin_dhx_skyblue";
		if( _getWinMan() && _getWinMan().skin ) {
			tCls = "dhtmlx_skin_" + _getWinMan().skin;
		}
		bodyPanel.addClass(tCls);

		var block = $("#bodyPanel_block");
		if( block ) {
			block.width(bodyPanel.width());
			block.height(bodyPanel.height());
		}

	}else {
		alert( "bodyPanelが存在しません。" );
	}
}

/**
 * パネルサイズを取得する。
 * @method getPanelSize
 * @return サイズを示す配列([0]:幅,[1]:高さ)
 */
function getPanelSize() {
	var bodyPanel = $("#bodyPanel");
	return [bodyPanel.width(), bodyPanel.height()];
}

/**
 * Bodyパネルを無効化/無効化解除する。
 * @method blockBodyPanel
 * @param flg true:Bodyパネルを無効化する,false:無効化解除する。
 */
function blockBodyPanel(flg) {
	if( flg ) {
		var bodyPanel = $("#bodyPanel");

		var tmp = bodyPanel.find("#bodyPanel_block");
		if( tmp.length == 0 ) {
			var blockIfr = $("<IFRAME id='bodyPanel_block_ifr' class='blender-body-panel-block-ifr'></IFRAME>");
			blockIfr.width(bodyPanel.width()-2);
			blockIfr.height(bodyPanel.height()-2);
			blockIfr.attr("src","javascript:false;");
			bodyPanel.prepend(blockIfr);
			// bodyタグ内にfalseの文字列が出力されないようにするため。
			var doc = blockIfr[0].contentWindow.document;
			doc.open().write('<body></body>');
			doc.close();

			var block = $("<DIV id='bodyPanel_block' class='blender-body-panel-block'></DIV>");

			block.width(bodyPanel.width());
			block.height(bodyPanel.height());
			block.click(function(e) {
				if( _getWinMan() ) {
					_getWinMan().hideMenuBar();
				}
				return false;
			});
			bodyPanel.append(block);
		}
		blockCnt++;
		//alert("ブロック！: "+blockCnt);
	}else {
		blockCnt--;
		//alert("ブロック解除: "+blockCnt);
		if( blockCnt == 0 ) {
			$("#bodyPanel_block").remove();
			$("#bodyPanel_block_ifr").remove();
		}
	}
}

/**
 * 入力ブロック中か判定する。
 * @method isBlocked
 * @return 入力ブロック中の場合true、ブロック中では無い場合false
 */
function isBlocked() {
	var bodyPanel = $("#bodyPanel");

	var tmp = bodyPanel.find("#bodyPanel_block");
	return (tmp.length>0);
}

/**
 * 編集中か判定する。
 * @method isDirty
 * @return 編集中の場合true、編集中では無い場合false
 */
function isDirty() {
	return dirtyFlg;
}

/**
 * 編集状態を設定する。
 * @method setDirty
 * @param flg true:編集中に設定、false:編集中では無いに設定
 */
function setDirty(flg) {
	dirtyFlg = flg;
}

/**
 * 編集中を無視するか判定する。
 * @method isIgnoreDirty
 * @return 編集中を無視する場合true、編集中を無視しない場合false
 */
function isIgnoreDirty() {
	return ignoreDirtyFlg;
}

/**
 * 編集中を無視するか設定する。
 * @method setIgnoreDirty
 * @param flg true:編集中を無視するに設定、false:編集中を無視しないに設定
 */
function setIgnoreDirty(flg) {
	ignoreDirtyFlg = flg;
}

/**
 * エラー有無を判定する。
 * @method hasError
 * @return エラー有の場合true、エラー無の場合false
 */
function hasError() {
	return errorFlg;
}

/**
 * エラー有無を設定する。
 * @method setError
 * @param flg true:エラー有に設定、false:エラー無に設定
 */
function setError(flg) {
	errorFlg = flg;
}

/**
 * 編集破棄を確認する。
 * @method checkDirtyClean
 * @param yesFunc yes選択時にコールバックされる関数(省略の場合、ウィンドウクローズ)
 * @param noFunc no選択時にコールバックされる関数(省略の場合、NOP)
 */
function checkDirtyClean(yesFunc,noFunc) {
	if( !yesFunc ) {
		yesFunc = function(){
			setIgnoreDirty(true);
			close(bizId,chainCloseFlag);
		};
	}
	if( !noFunc ) {
		noFunc = function(){
			chainCloseFlag = false;
		};
	}

	// 画面上のgridを取得し編集停止
	var grids = BlenderObjectManager.getObjectsByType("grid");
	for( var i=0; i<grids.length; i++ ) {
		grids[i].editStop();
	}
	if( BlenderMessageBox.isShowing(MessageConstants.MSG_C1001) ) {
		return;
	}

	BlenderMessageBox.show({
		"msg":MessageConstants.MSG_C1001,
		"type":BlenderMessageBox.MSG_TYPE_QUESTION,
		"yes":yesFunc,
		"no":noFunc
	});
}

/**
 * ウィンドウをクローズする。
 * @method close
 * @param bizId 業務ID
 * @param chainCloseFlag 連鎖クローズフラグ(デフォルト:false)
 */
function close(bizId,chainCloseFlag) {
	_getWinMan().closeParent(bizId,chainCloseFlag);
}

/**
 * ウィンドウ戻り値を設定する。
 * @method setReturnValue
 * @param key 戻り値-キー
 * @param value  戻り値-値
 */
function setReturnValue(key, value) {
	_getWinMan().window(bizId).setReturnValue(key, value);
}

/**
 * ウィンドウマネージャを取得する。
 * @method _getWinMan
 * @return ウィンドウマネージャ
 */
function _getWinMan() {
	return parent.winMan;
}

/**
 * onLoad 時に呼び出される。
 * @method loadOperationPanel
 */
function loadOperationPanel() {
}

/**
 * onUnload 時に呼び出される。
 * @method unloadOperationPanel
 */
function unloadOperationPanel() {
}

/**
 * 画面表示内容を更新する。
 * @method refresh
 */
function refresh() {
}

/**
 * オペレーションパネルをリサイズする。
 * (リサイズ時に callback される。)
 * @method resizeOperationPanel
 */
function resizeOperationPanel() {
}

/**
 * 画面コンポーネントの状態を調整する。
 * @method ctrlComponentsCondition
 */
function ctrlComponentsCondition(){
}

/**
 * 当該画面のダウンロード機能を呼び出す。
 * 本関数は特定のメニューアクションが実行した際に呼び出される。
 */
function doDownload(param) {
	BlenderMessageBox.show({
		"msg":MessageConstants.MSG_C2020,
		"type":BlenderMessageBox.MSG_TYPE_INFO
	});
}

/*
Copyright MITSUBISHI Elec.
*/
